export default {
    clickDisclaimerAgreeButton: 'click_disclaimer_agree_button',
    clickCreateAccountButton: 'click_create_account_button',
    clickConfirmOneTimePasscodeButton: 'click_confirm_otp_button',
    clickConfirmCreateAccountButton: 'click_confirm_create_account_button',
    registerFailed: 'register_failed',
    registerSuccess: 'register_success',
};
